import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type SplitType = 'Percentage' | 'Flat' | 'Custom';

interface SplitTypeOption {
  value: SplitType;
  label: string;
}

const OPTIONS: SplitTypeOption[] = [
  { value: 'Percentage', label: 'Percentage' },
  { value: 'Flat', label: 'Flat Fee' },
  { value: 'Custom', label: 'Custom' },
];

/** Three-way segmented control for choosing a sub-account split type (SCRUM-1228). */
@Component({
  selector: 'lib-split-type-selector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './split-type-selector.html',
  styleUrl: './split-type-selector.scss',
})
export class SplitTypeSelector {
  readonly options = OPTIONS;

  value = input<SplitType>('Percentage');
  disabled = input<boolean>(false);
  valueChange = output<SplitType>();

  select(option: SplitTypeOption): void {
    if (this.disabled() || option.value === this.value()) return;
    this.valueChange.emit(option.value);
  }

  onKeydown(event: KeyboardEvent, index: number): void {
    if (this.disabled()) return;

    let nextIndex: number | null = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % this.options.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + this.options.length) % this.options.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.options.length - 1;
    }

    if (nextIndex === null) return;
    event.preventDefault();
    this.select(this.options[nextIndex]);
    const nextTab = (event.currentTarget as HTMLElement)
      ?.closest('[role="radiogroup"]')
      ?.querySelectorAll<HTMLElement>('[role="radio"]')[nextIndex];
    nextTab?.focus();
  }
}
